import React from 'react';
import {observable, action, runInAction, toJS} from 'mobx';
import {observer} from 'mobx-react';
import {Row, Col, Switch, Modal, Button, Form, Upload, Avatar, Card, message, Divider, InputNumber} from 'antd';

import agent_detail_store from '@store/Agent/AgentDetailStore';
import agent_store, {pagination_store, filter_store} from '@store/Agent/AgentStore';
import agent_detail_pay_store from '@store/Agent/AgentDetailPayStore';
import {form_item_size} from '@common/theme';

const CardMeta = Card.Meta;
const FormItem = Form.Item;

@observer
class AgentDetailModal extends React.Component {
  constructor() {
    super();
  }

  @observable
  updateRadioLoading = false;

  render() {

    if (agent_detail_store.record == undefined)
    {
      return (<div></div>);
    }

    let col_layout = {
      label_col: 8,
      wrapper_col: 16
    };

    let row_style = {
      marginBottom: '10px'
    };

    let input_style = {
      width: '80px',
      textAlign: 'center'
    };


    return (
      <Modal
        visible={agent_detail_store.is_modal_show}
        title={(
          <div>
            <span>
              代理详细信息
            </span>
          </div>
        )}
        maskClosable={false}
        onCancel={() => {
          agent_detail_store.closeModal();
        }}
        footer={null}>
        <Card
          actions={[
            (
              <div>
                <div>投注收入</div>
                <div>￥{agent_detail_store.record.order_money}</div>
              </div>
            ),
            (
              <div>
                <div>下级代理</div>
                <div>{agent_detail_store.record.proxy_num}</div>
              </div>
            ),
            (
              <div>
                <div>所属会员</div>
                <div>{agent_detail_store.record.user_num}</div>
              </div>
            ),
          ]}
          cover={(
            <div>

            </div>
          )}>
          <CardMeta
            description={(
              <div>
                <Row style={row_style}>
                  <Col span={col_layout.label_col}>ID（邀请码）：</Col>
                  <Col span={col_layout.wrapper_col}>{agent_detail_store.record.proxy_number}</Col>
                </Row>
                <Row style={row_style}>
                  <Col span={col_layout.label_col}>代理等级：</Col>
                  <Col span={col_layout.wrapper_col}>{agent_detail_store.record.superior_level}</Col>
                </Row>
                <Row style={row_style}>
                  <Col span={col_layout.label_col}>注册时间：</Col>
                  <Col span={col_layout.wrapper_col}>{agent_detail_store.record.register_time}</Col>
                </Row>
                {/*<Row style={row_style}>*/}
                  {/*<Col span={col_layout.label_col}>上次登录IP：</Col>*/}
                  {/*<Col span={col_layout.wrapper_col}>{agent_detail_store.record.login_ip}</Col>*/}
                {/*</Row>*/}
                <Row style={row_style}>
                  <Col span={col_layout.label_col}>账号：</Col>
                  <Col span={col_layout.wrapper_col}>{agent_detail_store.record.nick_name}</Col>
                </Row>
                <Row style={row_style}>
                  <Col span={col_layout.label_col}>账户余额：</Col>
                  <Col span={col_layout.wrapper_col}>{agent_detail_store.record.balance}</Col>
                </Row>
                <Row style={row_style}>
                  <Col span={col_layout.label_col}>投注返佣：</Col>
                  <Col span={col_layout.wrapper_col}>
                    <InputNumber
                      placeholder=''
                      size={form_item_size}
                      style={input_style}
                      value={agent_detail_store.record.tempRadio}
                      max={100}
                      min={0}
                      precision={ 1 }
                      formatter={value => `${value}%`}
                      parser={value => value.replace('%', '')}
                      onChange={(value) => {
                        agent_detail_store.record.tempRadio = value;
                      }}
                      step={0.1}/>
                    <Button type="primary"
                            loading={this.updateRadioLoading}
                            onClick={async () => {
                              runInAction(() => {
                                this.updateRadioLoading = true;
                              });

                              let tempRecord = {
                                ...agent_detail_store.record
                              };
                              tempRecord.radio = agent_detail_store.record.tempRadio / 100;
                              let result;
                              result = await agent_store.proxyEdit(tempRecord);

                              runInAction(() => {
                                this.updateRadioLoading = false;
                              });

                              if (result.success) {
                                message.success(`修改 ${agent_detail_store.record.nick_name} 投注返佣成功！`, 3);
                                agent_detail_store.record.radio = result.data.radio;
                                // 重新拉取数据，刷新列表
                                agent_store.searchByFilter();
                              } else {
                                agent_detail_store.record.tempRadio = agent_detail_store.record.radio * 100;
                                message.error(`修改 ${agent_detail_store.record.nick_name} 投注返佣限失败！${ result.error.error_data }`, 3);
                              }
                            }}
                    >修改</Button>
                  </Col>
                </Row>
                <Row style={row_style}>
                  <Col span={col_layout.label_col}>允许代充：</Col>
                  <Col span={col_layout.wrapper_col}>
                    <Switch size='small'
                            defaultChecked={!agent_detail_store.record.is_wallet_type}
                            checked={!agent_detail_store.record.is_wallet_type}
                            onChange={async (checked) => {
                              let tempRecord = {
                                ...agent_detail_store.record
                              };
                              tempRecord.wallet_type = tempRecord.wallet_type == 0 ? 1 : 0;
                              let result;
                              result = await agent_store.proxyEdit(tempRecord);
                              if (result.success) {
                                message.success(`修改 ${agent_detail_store.record.nick_name} 代充值权限成功！`, 3);
                                agent_detail_store.record.wallet_type = Number(result.data.wallet_type);
                                // 重新拉取数据，刷新列表
                                agent_store.searchByFilter();
                              } else {
                                message.error(`修改 ${agent_detail_store.record.nick_name} 代充值权限失败！${ result.error.error_data }`, 3);
                              }
                            }}/>
                  </Col>
                </Row>
                <Row style={row_style}>
                  <Col span={col_layout.label_col}>允许发展下级：</Col>
                  <Col span={col_layout.wrapper_col}>
                    <Switch size='small'
                            defaultChecked={!agent_detail_store.record.is_recommended_status}
                            checked={!agent_detail_store.record.is_recommended_status}
                            onChange={async (checked) => {
                              let tempRecord = {
                                ...agent_detail_store.record
                              };
                              tempRecord.recommended_status = tempRecord.recommended_status == 0 ? 1 : 0;
                              let result;
                              result = await agent_store.proxyEdit(tempRecord);
                              if (result.success) {
                                message.success(`修改 ${agent_detail_store.record.nick_name} 代充值权限成功！`, 3);
                                agent_detail_store.record.recommended_status = Number(result.data.recommended_status);
                                // 重新拉取数据，刷新列表
                                agent_store.searchByFilter();
                              } else {
                                message.error(`修改 ${agent_detail_store.record.nick_name} 代充值权限失败！${ result.error.error_data }`, 3);
                              }
                            }}/>
                  </Col>
                </Row>
                <Row style={row_style}>
                  <Col span={col_layout.label_col}>允许提现：</Col>
                  <Col span={col_layout.wrapper_col}>
                    <Switch size='small'
                            defaultChecked={!agent_detail_store.record.is_wallet_status}
                            checked={!agent_detail_store.record.is_wallet_status}
                            onChange={async (checked) => {
                              let tempRecord = {
                                ...agent_detail_store.record
                              };
                              tempRecord.wallet_status = tempRecord.wallet_status == 0 ? 1 : 0;
                              let result;
                              result = await agent_store.proxyEdit(tempRecord);
                              if (result.success) {
                                message.success(`修改 ${agent_detail_store.record.nick_name} 代充值权限成功！`, 3);
                                agent_detail_store.record.wallet_status = Number(result.data.wallet_status);
                                // 重新拉取数据，刷新列表
                                agent_store.searchByFilter();
                              } else {
                                message.error(`修改 ${agent_detail_store.record.nick_name} 代充值权限失败！${ result.error.error_data }`, 3);
                              }
                            }}/>
                  </Col>
                </Row>
                <Row style={row_style}>
                  <Button size='large' block type='primary' onClick={() => {
                    agent_detail_pay_store.openModal({
                        ...agent_detail_store.record
                      },
                      (item) => {
                        agent_detail_store.updateRecord(item);
                        agent_store.searchByFilter();
                      }
                    )
                  }}>代充</Button>
                </Row>
              </div>
            )}
            title={agent_detail_store.record.pet_name}
            avatar={(
              <Avatar src={agent_detail_store.record.tailor_user_url}/>
            )}/>
        </Card>
      </Modal>
    )
  }

  componentWillMount() {

  }

  componentDidMount() {
  }
}

export default AgentDetailModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Agent/AgentList/AgentDetail/AgentDetailModal.jsx